import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';

@Component({
  selector: 'app-pos-reasons',
  templateUrl: './pos-reasons.component.html',
  styleUrls: ['./pos-reasons.component.scss'],
})
export class PosReasonsComponent implements OnInit {
  @Input() storeId: string = '';
  @Input() posReasons: {
    drawerReasons?: string[];
    returnReasons?: string[];
    priceChangeReasons?: string[];
    ageVerificationOverrideReasons?: string[];
  } = {};

  drawerReasons:                  string[] = ['', '', '', ''];
  returnReasons:                  string[] = ['', '', '', ''];
  priceChangeReasons:             string[] = ['', '', '', ''];
  ageVerificationOverrideReasons: string[] = ['', '', '', ''];

  isSaving = false;

  constructor(
    private service: ApiService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.drawerReasons                  = this.pad(this.posReasons?.drawerReasons                  ?? []);
    this.returnReasons                  = this.pad(this.posReasons?.returnReasons                  ?? []);
    this.priceChangeReasons             = this.pad(this.posReasons?.priceChangeReasons             ?? []);
    this.ageVerificationOverrideReasons = this.pad(this.posReasons?.ageVerificationOverrideReasons ?? []);
  }

  private pad(arr: string[]): string[] {
    const copy = [...arr];
    while (copy.length < 4) copy.push('');
    return copy.slice(0, 4);
  }

  private compact(arr: string[]): string[] {
    return arr.filter(s => s.trim().length > 0);
  }

  save(): void {
    this.isSaving = true;
    const payload = {
      posReasons: {
        drawerReasons:                  this.compact(this.drawerReasons),
        returnReasons:                  this.compact(this.returnReasons),
        priceChangeReasons:             this.compact(this.priceChangeReasons),
        ageVerificationOverrideReasons: this.compact(this.ageVerificationOverrideReasons),
      }
    };
    this.service.putRequest(`${ApiUrl.storeUpdateById}/${this.storeId}`, payload).subscribe({
      next: () => {
        this.isSaving = false;
        this.snackBar.open('POS reasons saved', 'OK', { duration: 3000 });
      },
      error: () => {
        this.isSaving = false;
        this.snackBar.open('Failed to save POS reasons', 'Close', { duration: 4000 });
      },
    });
  }
}
